import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography, Spin, message } from "antd";
import {
  UserOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { getAdminDashboardStats } from "../../services/Dashboard";

const { Title, Text } = Typography;

const AdminDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    pendingApprovals: 0,
    rejectedApprovals: 0,
    totalEyeAnalyses: 0,
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const data = await getAdminDashboardStats();
        console.log(data);
        setStats(data.analytics);
      } catch (error) {
        message.error("Failed to load admin dashboard data");
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, []);

  const cards = [
    {
      title: "Total Users",
      value: stats.totalUsers,
      icon: <TeamOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Active Users",
      value: stats.activeUsers,
      icon: <UserOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Pending Approvals",
      value: stats.pendingApprovals,
      icon: <CheckCircleOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Rejected Approvals",
      value: stats.rejectedApprovals,
      icon: <CloseCircleOutlined className="text-[#1c5a85] text-3xl" />,
    },
    {
      title: "Eye Analyses Performed",
      value: stats.totalEyeAnalyses,
      icon: <EyeOutlined className="text-[#1c5a85] text-3xl" />,
    },
  ];

  return (
    <div className="min-h-screen bg-white p-6">
      <Title level={4} className="!text-[#1c5a85] !font-semibold mb-6">
        Admin Dashboard Overview
      </Title>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Spin size="large" />
        </div>
      ) : (
        <Row gutter={[24, 24]}>
          {cards.map((stat, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card
                hoverable
                className="rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <Text className="text-gray-500 text-sm">{stat.title}</Text>
                    <Title level={3} className="!m-0 !text-[#1c5a85]">
                      {stat.value}
                    </Title>
                  </div>
                  <div className="bg-[#1c5a85]/10 p-3 rounded-full">
                    {stat.icon}
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default AdminDashboard;
